"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SessionTimeout;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactIdleTimer = require("react-idle-timer");
var _helper = require("../common_features/utility/helper");
var _Modal = require("@ccw-pwa-ui/Modal");
var _images = _interopRequireDefault(require("../common_features/assets/images"));
var _reactBootstrap = require("react-bootstrap");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function SessionTimeout(_ref) {
  let {
    handleLogout,
    isLoading
  } = _ref;
  const timeout = _helper.SESSION_TIMEOUT;
  const [showModal, setShowModal] = (0, _react.useState)(false);
  const {
    pause,
    reset
  } = (0, _reactIdleTimer.useIdleTimer)();
  const type = (0, _helper.getPlatformType)();
  const onIdle = () => {
    pause();
    reset();
    setShowModal(true);
    setTimeout(() => {
      handleLogout();
    }, [_helper.LOGOUT_TIMEOUT]);
  };
  const handleOnActive = () => {
    return true;
  };
  const handleOnIdle = () => onIdle();
  const {
    getRemainingTime,
    getElapsedTime
  } = (0, _reactIdleTimer.useIdleTimer)({
    timeout,
    onActive: handleOnActive,
    onIdle: handleOnIdle
  });
  const logout = () => {
    handleLogout();
  };
  (0, _react.useEffect)(() => {
    getRemainingTime();
    getElapsedTime();
  }, []);
  const handleLogoutButton = () => {
    reset();
    setShowModal(false);
    logout();
  };
  const handleSigninButton = () => {
    reset();
    setShowModal(false);
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Modal.Modal, {
    displayModal: type && showModal,
    modalHeaderText: "Session Timeout",
    modalDetailText: "Your session appears to be inactive. Please choose to stay logged in or to log off. Otherwise, you will be logged off automatically.",
    positiveActionButtonTitle: "Stay Logged In",
    negativeButtonActionTitle: "Log Off",
    positiveAction: handleSigninButton,
    negativeAvtion: handleLogoutButton,
    customIcon: /*#__PURE__*/_react.default.createElement("img", {
      src: _images.default.session.default,
      alt: ""
    }),
    modalHeaderTextStyle: {
      marginTop: "24px"
    },
    modalDetailTextStyle: {
      marginBottom: "40px"
    }
  }), isLoading ? /*#__PURE__*/_react.default.createElement("div", {
    className: "spinner-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Spinner, {
    animation: "border"
  })) : null);
}
SessionTimeout.propTypes = {
  handleLogout: _propTypes.default.func
};
SessionTimeout.defaultProps = {
  handleLogout: () => {}
};